const stMob = {
  containAppBottom: {
    top: 'auto',
    bottom: 0,
    backgroundColor: '#fff',
  },
  containToolbar: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
  buttomCupom: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginY: '5px',
  },
  textBtt: {
    textTransform: 'none',
    fontWeight: 'bold',
    textAlign: 'left',
    fontSize: '13px',
    width: '100%',
  },
}

export { stMob }
